import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from '@fino-ui/button';
import { SubmittableForm } from '@fino-ui/forms';
import { FinoInputModule } from '@fino-ui/input';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrl: './add-user.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslationModule,
    FormsModule,
    ReactiveFormsModule,
    FinoInputModule,
    ButtonModule,
  ],
})
export class AddUserComponent extends BaseModalComponent<
  {},
  {
    email: string;
    username: string;
    firstName: string;
    lastName: string;
  }
> {
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  form = new SubmittableForm({
    email: new FormControl('', [Validators.required, Validators.email]),
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
  });

  abort() {
    this.close();
  }

  get formNotTouched() {
    return this.form.pristine || this.form.invalid;
  }

  submit() {
    const values = this.form.value;
    this.result = { ...values, username: values.email };
    this.close();
  }
}
